import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.initVue();
    }

    initVue(){
        this.app = new Vue({
            el: this.el,
            data: {
                card:'',
                state: 'loading',
                token: this.el.dataset.token,
                order: false,
                freebees: false,
            },
            mounted() {
                this.getTransaction();
            },
            filters: {
                toDollar: function (value) {
                  return value / 100;
                }
            },
            methods: {
                submitForm(){
                    this.state = 'loading';
                    let fd = new FormData();
                    fd.append('action', 'Execute');
                    fd.append('email', this.order.email);
                    fd.append('total', this.order.total);
                    fd.append('order', JSON.stringify(this.order));
                    fd.append('card',this.card);
                    fd.append('items',JSON.stringify(this.order.items));
                    fetch('/wp-json/freebees/v1/reward',{method: "POST",body: fd})
                    .then(response => response.json())
                    .then(data => {
                        if(!data.success){
                            this.state = 'error';
                        } else {
                            this.order.metadata.freebees = true;
                            let data = {
                                "status": this.order.status,
                                "metadata": this.order.metadata
                            }
                            let fd = new FormData();
                            fd.append('token',this.token);
                            fd.append('data',JSON.stringify(data));
                            fetch('/wp-json/snipcart/v1/updateorder',{method: "POST",body: fd})
                            .then(response => response.json())
                            .then(data => {
                                this.order = data.data
                                this.state = 'done';
                            });
                            this.state = 'done';
                        }   
                    });
                },
                getTransaction(){
                    fetch('/wp-json/snipcart/v1/getorder?token='+this.token,{method: "GET"})
                    .then(response => response.json())
                    .then(data => {
                        this.order = data;
                        if(!this.order.metadata.freebees){
                            let fd = new FormData();
                            fd.append('total', this.order.total);
                            fd.append('items',JSON.stringify(this.order.items));
                            fetch('/wp-json/freebees/v1/reward',{method: "POST",body: fd})
                            .then(response => response.json())
                            .then(data => {
                                this.freebees = data.data
                                this.state = '';
                            });
                        }
                        else 
                            this.state = 'done';
                    });
                }
            }
        })
    }
}
